import { Injectable } from '@angular/core';
import {
  SessionActions,
  PaymentRulesActions,
} from '@arc/unified-payments-frontend/shared-stores';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, map, withLatestFrom } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { User, AuthUserStore } from '@arc/arc-shared-frontend';
import { Store, select } from '@ngrx/store';
import { DataDogService } from '../../services/data-dog.service';

@Injectable()
export class DatadogEffects {
  constructor(
    private userStore$: Store<User>,
    private paymentRulesActions$: Actions<PaymentRulesActions.PaymentRulesActionsUnion>,
    private actions$: Actions,
    private datadogService: DataDogService,
  ) {}

  recordUserTags$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SessionActions.UpdateRUMSessionTagsAction),
        withLatestFrom(this.userStore$.pipe(select(AuthUserStore))),
        exhaustMap(([, user]) => {
          this.datadogService.recordUser(user.user);
          return EMPTY;
        }),
      ),
    { dispatch: false },
  );

  recordUserTenantTags$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SessionActions.UpdateRUMSessionTagsAction),
        withLatestFrom(this.userStore$.pipe(select(AuthUserStore))),
        exhaustMap(([, user]) => {
          this.datadogService.recordUserTenant(user.activeTenant);
          return EMPTY;
        }),
      ),
    { dispatch: false },
  );

  recordUserSessionTags$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SessionActions.UpdateRUMSessionTagsAction),
        map((action) => {
          this.datadogService.recordUserSession(action.payload);
          return EMPTY;
        }),
      ),
    { dispatch: false },
  );

  recordUserPaymentRulesTags$ = createEffect(
    () =>
      this.paymentRulesActions$.pipe(
        ofType(PaymentRulesActions.UpdateRUMPaymentRulesTagsAction.type),
        map((action) => {
          this.datadogService.recordUserPaymentRules(action.payload);
          return EMPTY;
        }),
      ),
    { dispatch: false },
  );

  recordUserPaymentTags$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SessionActions.UpdateRUMPaymentTagsAction),
        map((action) => {
          this.datadogService.recordUserPayment(action.payload);
          return EMPTY;
        }),
      ),
    { dispatch: false },
  );
}
